const PENDING_CHECKOUT_KEY = "zooi_pending_checkout";
const MAX_AGE_MS = 2 * 60 * 60 * 1000; // 2 hours

export interface PendingCheckout {
  email: string;
  cartItems: Array<{
    title: string;
    variantId: string;
    quantity: number;
    price: string;
  }>;
  totalValue: number;
  savedAt: number;
}

/** Save checkout context before redirecting to Shopify */
export function savePendingCheckout(data: Omit<PendingCheckout, "savedAt">) {
  try {
    localStorage.setItem(
      PENDING_CHECKOUT_KEY,
      JSON.stringify({ ...data, savedAt: Date.now() })
    );
  } catch {
    // localStorage full or unavailable
  }
}

export function clearPendingCheckout() {
  localStorage.removeItem(PENDING_CHECKOUT_KEY);
}

export function getPendingCheckout(): PendingCheckout | null {
  try {
    const raw = localStorage.getItem(PENDING_CHECKOUT_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw) as PendingCheckout;
    if (Date.now() - data.savedAt > MAX_AGE_MS) {
      clearPendingCheckout();
      return null;
    }
    return data;
  } catch {
    clearPendingCheckout();
    return null;
  }
}
